/* Funky Buddha Wholesale pages — v1-0 */
(function () {
  if (window.FBWholesaleV1_0) return;
  window.FBWholesaleV1_0 = true;

  function setConditionalState(element, visible) {
    element.hidden = !visible;
    element.querySelectorAll('input, select, textarea').forEach(function (field) {
      field.disabled = !visible;
      field.required = visible && field.dataset.requiredWhenVisible === 'true';
    });
  }

  function value(form, name) {
    var checked = form.querySelector('[name="' + name + '"]:checked');
    var field = checked || form.querySelector('[name="' + name + '"]');
    return field ? field.value : '';
  }

  function updateGreekForm(form) {
    var storeType = value(form, 'contact[Store type]');
    var eshop = value(form, 'contact[Has e-shop]');
    var marketplaces = value(form, 'contact[Sells on marketplaces]');
    form.querySelectorAll('[data-show-store-other]').forEach(function (element) { setConditionalState(element, storeType === 'Other'); });
    form.querySelectorAll('[data-show-eshop]').forEach(function (element) { setConditionalState(element, eshop === 'Yes'); });
    form.querySelectorAll('[data-show-marketplaces]').forEach(function (element) { setConditionalState(element, marketplaces === 'Yes'); });
  }

  function restrictedDistributionCountry(country) {
    return ['North Macedonia', 'Georgia', 'Armenia', 'Kazakhstan', 'Uzbekistan', 'Azerbaijan'].indexOf(country) !== -1;
  }

  function updateInternationalForm(form) {
    var partnership = value(form, 'contact[Partnership type]');
    var country = value(form, 'contact[Country]');
    var brands = value(form, 'contact[Represents apparel brands]');
    var stores = value(form, 'contact[Operates retail stores]');
    var isDistribution = ['Distributor', 'Importer', 'Wholesaler'].indexOf(partnership) !== -1;
    var isAgency = partnership === 'Agency';
    var needsProposal = isAgency || partnership === 'Other';

    form.querySelectorAll('[data-show-brands]').forEach(function (element) { setConditionalState(element, brands === 'Yes'); });
    form.querySelectorAll('[data-show-proposal]').forEach(function (element) { setConditionalState(element, needsProposal); });
    form.querySelectorAll('[data-show-distribution]').forEach(function (element) { setConditionalState(element, isDistribution); });
    form.querySelectorAll('[data-show-agency]').forEach(function (element) { setConditionalState(element, isAgency); });
    form.querySelectorAll('[data-show-stores]').forEach(function (element) { setConditionalState(element, isDistribution && stores === 'Yes'); });
    form.querySelectorAll('[data-show-qualification]').forEach(function (element) { element.hidden = !(isDistribution || isAgency); });

    var route = '';
    if (isDistribution && country === 'Greece') route = 'greece';
    else if (isDistribution && country === 'Cyprus') route = 'cyprus';
    else if (isDistribution && restrictedDistributionCountry(country)) route = 'restricted';

    form.querySelectorAll('[data-routing-message]').forEach(function (element) {
      element.hidden = element.dataset.routingMessage !== route;
    });

    var submit = form.querySelector('[type="submit"]');
    if (submit) {
      submit.disabled = route !== '';
      submit.setAttribute('aria-disabled', String(route !== ''));
    }
    form.dataset.blockedRoute = route;
  }

  function updateForm(form) {
    if (form.dataset.formVariant === 'greek') updateGreekForm(form);
    if (form.dataset.formVariant === 'international') updateInternationalForm(form);
    validateCheckboxGroups(form);
  }

  function validateCheckboxGroups(form) {
    form.querySelectorAll('[data-fbw-required-group]').forEach(function (group) {
      var boxes = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]:not(:disabled)'));
      if (!boxes.length) return;
      var valid = boxes.some(function (box) { return box.checked; });
      var message = form.dataset.locale === 'el' ? 'Επιλέξτε τουλάχιστον μία επιλογή.' : 'Select at least one option.';
      boxes[0].setCustomValidity(valid ? '' : message);
    });
  }

  function sortCountryOptions(form) {
    form.querySelectorAll('select[data-fbw-country-select]').forEach(function (select) {
      if (select.dataset.fbwCountrySorted === 'true') return;
      var selected = select.value;
      var locale = select.dataset.fbwCountryLocale || document.documentElement.lang || 'en';
      var options = Array.prototype.slice.call(select.options);
      var placeholders = options.filter(function (option) { return option.value === '' || option.disabled; });
      var countries = options.filter(function (option) { return placeholders.indexOf(option) === -1; });
      var collator = typeof Intl !== 'undefined' && Intl.Collator ? new Intl.Collator(locale, { usage: 'sort', sensitivity: 'base', ignorePunctuation: true }) : null;
      countries.sort(function (a, b) {
        var first = a.textContent.trim();
        var second = b.textContent.trim();
        return collator ? collator.compare(first, second) : first.localeCompare(second, locale);
      });
      var fragment = document.createDocumentFragment();
      placeholders.concat(countries).forEach(function (option) { fragment.appendChild(option); });
      select.appendChild(fragment);
      select.value = selected;
      select.dataset.fbwCountrySorted = 'true';
    });
  }

  function storageKey(form) {
    return 'fbw-form-' + form.id;
  }

  function saveForm(form) {
    try {
      var data = {};
      form.querySelectorAll('input, select, textarea').forEach(function (field) {
        if (!field.name || field.type === 'hidden' || field.type === 'submit' || field.dataset.fbwHoneypot !== undefined) return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        if (field.type === 'checkbox') {
          if (!data[field.name]) data[field.name] = [];
          data[field.name].push(field.value);
        } else data[field.name] = field.value;
      });
      sessionStorage.setItem(storageKey(form), JSON.stringify(data));
    } catch (error) {}
  }

  function restoreForm(form) {
    if (!form.querySelector('[data-fbw-form-errors]')) return;
    try {
      var raw = sessionStorage.getItem(storageKey(form));
      if (!raw) return;
      var data = JSON.parse(raw);
      form.querySelectorAll('input, select, textarea').forEach(function (field) {
        if (!field.name || data[field.name] === undefined) return;
        if (field.type === 'radio') field.checked = field.value === data[field.name];
        else if (field.type === 'checkbox') field.checked = Array.isArray(data[field.name]) && data[field.name].indexOf(field.value) !== -1;
        else field.value = data[field.name];
      });
    } catch (error) {}
  }

  function clearStoredForm(form) {
    try { sessionStorage.removeItem(storageKey(form)); } catch (error) {}
  }

  function syncReturnTo(form, submitted) {
    var returnField = form.querySelector('input[name="return_to"]');
    if (!returnField) return;
    var url = new URL(window.location.href);
    if (submitted) url.searchParams.set('fbw_submitted', form.id);
    else url.searchParams.delete('fbw_submitted');
    returnField.value = url.pathname + url.search;
  }

  function initForm(form) {
    if (form.dataset.fbwReady === 'true') return;
    form.dataset.fbwReady = 'true';
    var submissionField = form.querySelector('input[name="contact[Submission type]"]');
    var languageField = form.querySelector('input[name="contact[Language]"]');
    form.dataset.formVariant = submissionField && submissionField.value === 'WHOLESALE GREECE' ? 'greek' : 'international';
    form.dataset.locale = languageField ? languageField.value.toLowerCase() : 'en';
    syncReturnTo(form, false);
    sortCountryOptions(form);
    restoreForm(form);
    updateForm(form);
    form.addEventListener('change', function () { updateForm(form); });
    form.addEventListener('input', function () { saveForm(form); });
    form.addEventListener('submit', function (event) {
      validateCheckboxGroups(form);
      var trap = form.querySelector('[data-fbw-honeypot]');
      if ((trap && trap.value) || form.dataset.blockedRoute) {
        event.preventDefault();
        return;
      }
      saveForm(form);
      syncReturnTo(form, true);
    });
  }

  function emitConversion(success) {
    if (success.dataset.fbwEventSent === 'true') return;
    success.dataset.fbwEventSent = 'true';
    var type = success.dataset.submissionType || 'WHOLESALE';
    document.dispatchEvent(new CustomEvent('fb:wholesale:form_success', { detail: { submissionType: type } }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'wholesale_form_success', wholesale_submission_type: type });
  }

  function revealClientSuccess(root) {
    var url = new URL(window.location.href);
    var submittedId = url.searchParams.get('fbw_submitted');
    if (!submittedId) return;
    var scope = root || document;
    var form = document.getElementById(submittedId);
    if (!form) return;
    if (form.querySelector('[data-fbw-form-errors]')) {
      url.searchParams.delete('fbw_submitted');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      return;
    }
    var section = form.closest('.fb-wholesale--form');
    var fallback = section && section.querySelector('[data-fbw-form-success-fallback]');
    if (!fallback) return;
    form.hidden = true;
    fallback.hidden = false;
    clearStoredForm(form);
    url.searchParams.delete('fbw_submitted');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }

  function focusSuccess(root) {
    (root || document).querySelectorAll('[data-fbw-form-success]:not([hidden]), [data-fbw-form-success-fallback]:not([hidden])').forEach(function (success) {
      if (success.dataset.fbwSuccessReady === 'true') return;
      success.dataset.fbwSuccessReady = 'true';
      var relatedForm = success.closest('form') || (success.closest('.fb-wholesale--form') && success.closest('.fb-wholesale--form').querySelector('form.fb-wholesale__form'));
      if (relatedForm) clearStoredForm(relatedForm);
      emitConversion(success);
      window.requestAnimationFrame(function () {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        success.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        try { success.focus({ preventScroll: true }); } catch (error) { success.focus(); }
      });
    });
  }

  function trackOutbound(root) {
    (root || document).querySelectorAll('[data-fbw-outbound]').forEach(function (link) {
      if (link.dataset.fbwTracked === 'true') return;
      link.dataset.fbwTracked = 'true';
      link.addEventListener('click', function () {
        var destination = link.dataset.fbwOutbound;
        document.dispatchEvent(new CustomEvent('fb:wholesale:outbound', { detail: { destination: destination, href: link.href } }));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'wholesale_outbound_click', wholesale_destination: destination });
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('form.fb-wholesale__form').forEach(initForm);
    revealClientSuccess(root || document);
    focusSuccess(root || document);
    trackOutbound(root || document);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
